import React from 'react';
import RouteList from './RouteList';
import 'antd/dist/antd.min.css';

function App() {
  return <RouteList />;
}

export default App;
